import React, { useEffect, useRef, useState } from 'react';
import './customCard.css';
export default function CustomCard({ cardData, canvasRef, smallCardCanvasRef }) {
    const [playerImage, setSelectedImage] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const objectURL = URL.createObjectURL(file);
            setSelectedImage(objectURL);
        }
    };

    const lightbgArray = [
        "normalstar.png",
        "normalchampions.png",
        "normalclassic.png",
        "maxedstar.png",
        "maxedchampions.png",
        "maxedclassic.png"
    ];
    // Note: Do not mark Team of 2025 backgrounds as "light" here — they use dark text backgrounds
    // so we intentionally do not add normal25/maxed25 to this list. If you later add
    // filenames that should be treated as light backgrounds, add them to this array.
    const countryList = {
        "Spain": "0",
        "Italy": "1",
        "France": "2",
        "Zimbabwe": "3",
        "El Salvador": "4",
        "Haiti": "5",
        "Cuba": "6",
        "Saint Kitts and Nevis": "7",
        "Puerto Rico": "8",
        "Armenia": "9",
        "Estonia": "10",
        "Burundi": "11",
        "Tanzania": "12",
        "Russia": "13",
        "Cyprus": "14",
        "Moldova": "15",
        "Faroe Islands": "16",
        "Kosovo": "17",
        "Saint Vincent and the Grenadines": "18",
        "Bermuda": "19",
        "Syria": "20",
        "Uzbekistan": "21",
        "Panama": "22",
        "Kazakhstan": "23",
        "Cameroon": "24",
        "San Marino": "25",
        "Democratic Republic of the Congo": "26",
        "Kuwait": "27",
        "Liechtenstein": "28",
        "Azerbaijan": "29",
        "Luxembourg": "30",
        "Libya": "31",
        "Zambia": "32",
        "Guyana": "33",
        "Antigua and Barbuda": "34",
        "England": "35",
        "Iraq": "36",
        "Jordan": "37",
        "Qatar": "38",
        "Bahrain": "39",
        "New Caledonia": "40",
        "French Polynesia": "41",
        "Thailand": "42",
        "Vietnam": "43",
        "Malaysia": "44",
        "Indonesia": "45",
        "Scotland": "46",
        "United Arab Emirates": "47",
        "Singapore": "48",
        "Hong Kong": "49",
        "USSR": "50",
        "Bangladesh": "51",
        "Republic of the Congo": "52",
        "Mozambique": "53",
        "Curacao": "54",
        "Philippines": "55",
        "Mauritania": "56",
        "Greece": "57",
        "Myanmar": "58",
        "Kyrgyzstan": "59",
        "Laos": "60",
        "Benin": "61",
        "Chad": "62",
        "Belize": "63",
        "Sri Lanka": "64",
        "Lebanon": "65",
        "Nepal": "66",
        "Yemen": "67",
        "Ghana": "68",
        "Bahamas": "69",
        "Bhutan": "70",
        "Botswana": "71",
        "Cambodia": "72",
        "Dominica": "73",
        "Dominican Republic": "74",
        "Fiji": "75",
        "Madagascar": "76",
        "Mauritius": "77",
        "Mongolia": "78",
        "Egypt": "79",
        "Montserrat": "80",
        "Namibia": "81",
        "Nicaragua": "82",
        "Rwanda": "83",
        "Seychelles": "84",
        "Eswatini": "85",
        "United Kingdom": "86",
        "Central African Republic": "87",
        "Equatorial Guinea": "88",
        "Suriname": "89",
        "Uruguay": "90",
        "Comoros": "91",
        "Palestine": "92",
        "Guinea-Bissau": "93",
        "South Sudan": "94",
        "Ivory Coast": "95",
        "Germany": "96",
        "Mexico": "97",
        "Paraguay": "98",
        "Nigeria": "99",
        "Niger": "100",
        "United States of America": "101",
        "Colombia": "102",
        "Poland": "103",
        "Sweden": "104",
        "Ulster": "105",
        "Japan": "106",
        "Netherlands": "107",
        "Morocco": "108",
        "Ireland": "109",
        "Australia": "110",
        "Chile": "111",
        "Tunisia": "112",
        "Senegal": "113",
        "Iran": "114",
        "Saudi Arabia": "115",
        "South Korea": "116",
        "Ecuador": "117",
        "Croatia": "118",
        "Wales": "119",
        "Honduras": "120",
        "Venezuela": "121",
        "South Africa": "122",
        "Costa Rica": "123",
        "Trinidad and Tobago": "124",
        "Canada": "125",
        "China": "126",
        "Jamaica": "127",
        "North Korea": "128",
        "Brazil": "129",
        "Barbados": "130",
        "India": "131",
        "Belgium": "132",
        "Switzerland": "133",
        "Denmark": "134",
        "Bulgaria": "135",
        "Togo": "136",
        "Norway": "137",
        "Slovakia": "138",
        "Israel": "139",
        "Argentina": "140",
        "Ukraine": "141",
        "Peru": "142",
        "Mali": "143",
        "Romania": "144",
        "Guinea": "145",
        "Serbia": "146",
        "Montenegro": "147",
        "Bosnia and Herzegovina": "148",
        "Iceland": "149",
        "Algeria": "150",
        "Czech Republic": "151",
        "Hungary": "152",
        "Albania": "153",
        "Somalia": "154",
        "Oman": "155",
        "Slovenia": "156",
        "Angola": "157",
        "Belarus": "158",
        "Lithuania": "159",
        "Turkey": "160",
        "Kenya": "161",
        "Democratic Republic of the Congo": "162",
        "Cape Verde": "163",
        "Austria": "164",
        "Guadeloupe": "165",
        "Finland": "166",
        "Uganda": "167",
        "Malta": "168",
        "Gabon": "169",
        "Sierra Leone": "170",
        "Pakistan": "171",
        "Guatemala": "172",
        "Yugoslavia": "173",
        "Liberia": "174",
        "New Zealand": "175",
        "Bolivia": "176",
        "Portugal": "177",
        "Republic of The Gambia": "178",
        "Georgia": "179",
        "World": "180",
        "Grenada": "181",
        "Macedonia": "182",
        "Latvia": "183"
    }
    function getColor(value, type) {
        if (lightbgArray.includes(value) && type === 'string') {
            console.log(value)
            return '#000';
        } else if (type === 'string' && !lightbgArray.includes(value)) {
            return '#fff';
        }
        if (type === 'number') {
            const v = Number(value);
            if (v < 50) return '#ec0f21';
            if (v < 60) return '#ec4b62';
            if (v < 70) return '#ffb91a';
            if (v < 80) return '#ebdc1c';
            if (v < 90) return '#1ccd1b';
            return '#21d2c6';
        }
    }
    function getBackgroundImage(playerType, cardType, rating) {
        if (cardData.Position !== "GK") {
            // Ensure rating is a number
            const r = Number(rating);

            // Champion
            if (playerType === 'Champion' && cardType === 'Normal') {
                return 'images/bg/mainbg/normalchampions.png';
            }
            if (playerType === 'Champion' && cardType === 'Maxed') {
                return 'images/bg/mainbg/maxedchampions.png';
            }

            // Team of 2025
            if (playerType === 'Team of 2025' && cardType === 'Normal') {
                // Prefer the shorter filenames added by the user, fallback to the older teamof2025 name
                return 'images/bg/mainbg/normal25.png';
            }
            if (playerType === 'Team of 2025' && cardType === 'Maxed') {
                return 'images/bg/mainbg/maxed25.png';
            }

            // Star
            if (playerType === 'Star' && cardType === 'Normal') {
                return 'images/bg/mainbg/normalstar.png';
            }
            if (playerType === 'Star' && cardType === 'Maxed') {
                return 'images/bg/mainbg/maxedstar.png';
            }

            // Classic
            if (playerType === 'Classic' && cardType === 'Normal') {
                return 'images/bg/mainbg/normalclassic.png';
            }
            if (playerType === 'Classic' && cardType === 'Maxed') {
                return 'images/bg/mainbg/maxedclassic.png';
            }

            // Normal
            if (playerType === 'Normal' && cardType === 'Normal') {
                if (r < 70) return 'images/bg/mainbg/normal069.png';
                if (r < 80) return 'images/bg/mainbg/normal7079.png';
                return 'images/bg/mainbg/normal80100.png';
            }
            if (playerType === 'Normal' && cardType === 'Maxed') {
                if (r <= 69) return 'images/bg/mainbg/maxed069.png';
                if (r <= 79) return 'images/bg/mainbg/maxed7079.png';
                return 'images/bg/mainbg/maxed80100.png';
            }
        } else {
            // Ensure rating is a number
            const r = Number(rating);

            // Champion
            if (playerType === 'Champion' && cardType === 'Normal') {
                return 'images/bg/mainbg/GK/normalchampions.png';
            }
            if (playerType === 'Champion' && cardType === 'Maxed') {
                return 'images/bg/mainbg/GK/maxedchampions.png';
            }

            // Team of 2025 (GK)
            if (playerType === 'Team of 2025' && cardType === 'Normal') {
                return 'images/bg/mainbg/GK/normal25gk.png';
            }
            if (playerType === 'Team of 2025' && cardType === 'Maxed') {
                return 'images/bg/mainbg/GK/maxed25gk.png';
            }

            // Star
            if (playerType === 'Star' && cardType === 'Normal') {
                return 'images/bg/mainbg/GK/normalstar.png';
            }
            if (playerType === 'Star' && cardType === 'Maxed') {
                return 'images/bg/mainbg/GK/maxedstar.png';
            }

            // Classic
            if (playerType === 'Classic' && cardType === 'Normal') {
                return 'images/bg/mainbg/GK/normalclassic.png';
            }
            if (playerType === 'Classic' && cardType === 'Maxed') {
                return 'images/bg/mainbg/GK/maxedclassic.png';
            }

            // Normal
            if (playerType === 'Normal' && cardType === 'Normal') {
                if (r < 70) return 'images/bg/mainbg/GK/normal069.png';
                if (r < 80) return 'images/bg/mainbg/GK/normal7079.png';
                return 'images/bg/mainbg/GK/normal80100.png';
            }
            if (playerType === 'Normal' && cardType === 'Maxed') {
                if (r <= 69) return 'images/bg/mainbg/GK/maxed069.png';
                if (r <= 79) return 'images/bg/mainbg/GK/maxed7079.png';
                return 'images/bg/mainbg/GK/maxed80100.png';
            }
        }

        // Default fallback
        return 'images/bg/mainbg/default.png';
    }

    function getSmallBackgroundImage(playerType, cardType, rating) {
        // Ensure rating is a number
        const r = Number(rating);

        // Champion
        if (playerType === 'Champion' && cardType === 'Normal') {
            return 'images/bg/smallbg/normalchampions.png';
        }
        if (playerType === 'Champion' && cardType === 'Maxed') {
            return 'images/bg/smallbg/maxedchampions.png';
        }

        // Team of 2025 (small)
        if (playerType === 'Team of 2025' && cardType === 'Normal') {
            return 'images/bg/smallbg/normal25.png';
        }
        if (playerType === 'Team of 2025' && cardType === 'Maxed') {
            return 'images/bg/smallbg/maxed25.png';
        }

        // Star
        if (playerType === 'Star' && cardType === 'Normal') {
            return 'images/bg/smallbg/normalstar.png';
        }
        if (playerType === 'Star' && cardType === 'Maxed') {
            return 'images/bg/smallbg/maxedstar.png';
        }

        // Classic
        if (playerType === 'Classic' && cardType === 'Normal') {
            return 'images/bg/smallbg/normalclassic.png';
        }
        if (playerType === 'Classic' && cardType === 'Maxed') {
            return 'images/bg/smallbg/maxedclassic.png';
        }

        // Normal
        if (playerType === 'Normal' && cardType === 'Normal') {
            if (r < 70) return 'images/bg/smallbg/normal069.png';
            if (r < 80) return 'images/bg/smallbg/normal7079.png';
            return 'images/bg/smallbg/normal80100.png';
        }
        if (playerType === 'Normal' && cardType === 'Maxed') {
            if (r <= 69) return 'images/bg/smallbg/maxed069.png';
            if (r <= 79) return 'images/bg/smallbg/maxed7079.png';
            return 'images/bg/smallbg/maxed80100.png';
        }

        // Default fallback
        return 'images/bg/smallbg/default.png';
    }

    function getRatingBackgroundImage(cardType, rating) {
        const r = Number(rating);

        let range = '';
        if (r <= 59) range = '059';
        else if (r <= 69) range = '6069';
        else if (r <= 79) range = '7079';
        else if (r <= 89) range = '8089';
        else range = '90100';

        // Example: images/bg/mainbg/normal-0059.png or maxed-7079.png
        if (cardType === 'Normal') {
            return `images/bg/ratingbg/${range}rating.png`;
        } else if (cardType === 'Maxed') {
            return `images/bg/ratingbg/${range}maxed.png`;
        }

        // Default fallback
        return 'images/bg/mainbg/default.png';
    }
    function loadImage(src) {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.src = src;
        });
    }

    function squeezeText(ctx, text, maxWidth, font) {
        ctx.font = font;
        const textWidth = ctx.measureText(text).width;
        if (textWidth > maxWidth) {
            return maxWidth / textWidth; // scaleX factor
        }
        return 1; // normal width
    }

    useEffect(() => {
        const circles = [
            { x: 100, y: 278, r: 35, value: cardData.Speed, color: getColor(cardData.Speed, 'number'), font: '65' },
            { x: 260, y: 278, r: 35, value: cardData.Acceleration, color: getColor(cardData.Acceleration, 'number'), font: '65' },
            { x: 425, y: 278, r: 35, value: cardData.Stamina, color: getColor(cardData.Stamina, 'number'), font: '65' },
            { x: 585, y: 278, r: 35, value: cardData.Strength, color: getColor(cardData.Strength, 'number'), font: '65' },
            { x: 100, y: 518, r: 35, value: cardData.Control, color: getColor(cardData.Control, 'number'), font: '65' },
            { x: 260, y: 518, r: 35, value: cardData.Passing, color: getColor(cardData.Passing, 'number'), font: '65' },
            { x: 425, y: 518, r: 35, value: cardData.Shooting, color: getColor(cardData.Shooting, 'number'), font: '65' },
            { x: 585, y: 518, r: 35, value: cardData.Tackling, color: getColor(cardData.Tackling, 'number'), font: '65' },
            { x: 100, y: 690, r: 35, value: cardData.Height + 'cm', color: '#fff', font: '45' },
            { x: 300, y: 690, r: 35, value: cardData.Foot, color: '#fff', font: '45' }
        ];

        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');

        // Prepare all image sources
        const bgSrc = getBackgroundImage(cardData.PlayerType, cardData.CardType, cardData.Rating);
        const yearBg = `images/bg/yearbg.png`;
        const coinImg = `images/coin.png`;
        const ratingBgSrc = getRatingBackgroundImage(cardData.CardType, cardData.Rating);
        const posSrc = `images/positions/${cardData.Position}.png`;
        const flagSrc = `images/flags/${countryList[cardData.Nationality]}.png`;
        const playerSrc = playerImage ? playerImage : 'images/playerImages/default_pic.png';

        Promise.all([
            loadImage(bgSrc),
            loadImage(ratingBgSrc),
            loadImage(posSrc),
            loadImage(flagSrc),
            loadImage(playerSrc),
            loadImage(coinImg),
            loadImage(yearBg)
        ]).then(([bgImg, ratingImg, posImg, flagImg, playerImg, coinImg, yearBg]) => {
            // Draw background
            canvas.width = 1174;
            canvas.height = 720;
            ctx.clearRect(0, 0, 1174, 720);
            ctx.drawImage(bgImg, 0,0, 1174, 720);

            // Draw player image
            ctx.drawImage(playerImg, 818, 115, 272, 272);

            //Draw coin image 
            if (cardData.ShowPrice === "Show") {
                ctx.drawImage(coinImg, 970, 588, 245, 150);
            }

            // Draw rating background and number
            const x = 720, y = 130, w = 160, h = 160, radius = 4;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + w - radius, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
            ctx.lineTo(x + w, y + h - radius);
            ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
            ctx.lineTo(x + radius, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(ratingImg, x, y, w, h);
            ctx.restore();

            // Squeeze the rating number if needed
            ctx.save();
            const ratingText = cardData.Rating.toString();
            const ratingFont = '64px Renogare';
            const ratingMaxWidth = 120; // adjust as needed
            const ratingScaleX = squeezeText(ctx, ratingText, ratingMaxWidth, ratingFont);
            ctx.font = ratingFont;
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.translate(x + w / 2, y + h / 2 + 12.5);
            ctx.scale(ratingScaleX, 1); // squeeze horizontally if needed
            ctx.fillText(ratingText, 0, 0);
            ctx.restore();

            // Draw position image
            {
                const px = 918.5, py = 477, pw = 70, ph = 42, pr = 4;
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(px + pr, py);
                ctx.lineTo(px + pw - pr, py);
                ctx.quadraticCurveTo(px + pw, py, px + pw, py + pr);
                ctx.lineTo(px + pw, py + ph - pr);
                ctx.quadraticCurveTo(px + pw, py + ph, px + pw - pr, py + ph);
                ctx.lineTo(px + pr, py + ph);
                ctx.quadraticCurveTo(px, py + ph, px, py + ph - pr);
                ctx.lineTo(px, py + pr);
                ctx.quadraticCurveTo(px, py, px + pr, py);
                ctx.closePath();
                ctx.clip();
                ctx.drawImage(posImg, px, py, pw, ph);
                ctx.restore();
            }

            // Draw flag image
            {
                const fx = 830, fy = 477, fw = 70, fh = 42, fr = 4;
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(fx + fr, fy);
                ctx.lineTo(fx + fw - fr, fy);
                ctx.quadraticCurveTo(fx + fw, fy, fx + fw, fy + fr);
                ctx.lineTo(fx + fw, fy + fh - fr);
                ctx.quadraticCurveTo(fx + fw, fy + fh, fx + fw - fr, fy + fh);
                ctx.lineTo(fx + fr, fy + fh);
                ctx.quadraticCurveTo(fx, fy + fh, fx, fy + fh - fr);
                ctx.lineTo(fx, fy + fr);
                ctx.quadraticCurveTo(fx, fy, fx + fr, fy);
                ctx.closePath();
                ctx.clip();
                ctx.drawImage(flagImg, fx, fy, fw, fh);
                ctx.restore();
            }

            // Draw name and last name
            ctx.save();

            if (cardData.Position === "GK") {
                    ctx.fillStyle = getColor(bgSrc.split('/')[4], 'string');
                } else {
                    ctx.fillStyle = getColor(bgSrc.split('/')[3], 'string');
                }
            const nameText = (cardData.Name + ' ' + cardData.LastName).toUpperCase();
            const nameFont = '67px Renogare';
            const nameMaxWidth = 1100; // adjust as needed
            const nameScaleX = squeezeText(ctx, nameText, nameMaxWidth, nameFont);
            ctx.font = nameFont;
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';
            ctx.translate(40, 68); // move origin to text position
            ctx.scale(nameScaleX, 1); // squeeze horizontally if needed
            ctx.fillText(nameText, 0, 0);
            ctx.restore();

            // Draw last name (centered)
            ctx.save();
            ctx.fillStyle = '#000';
            const lastNameText = cardData.LastName.toUpperCase();
            const lastNameFont = '53px Renogare';
            const lastNameMaxWidth = 340; // adjust as needed
            const lastNameScaleX = squeezeText(ctx, lastNameText, lastNameMaxWidth, lastNameFont);
            ctx.font = lastNameFont;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.translate(905, 429); // move origin to text position
            ctx.scale(lastNameScaleX, 1); // squeeze horizontally if needed
            ctx.fillText(lastNameText, 0, 0);
            ctx.restore();
            if (cardData.PlayerType !== 'Normal') {
                // Draw year background
                ctx.drawImage(yearBg, 680, 275, 260, 140);
                ctx.fillStyle = '#FFF700';
                const yearFont = '50px Renogare'
                ctx.textAlign = 'center';
                ctx.font = yearFont;
                const yearText = cardData.Year.toString();
                ctx.textBaseline = 'middle';
                const yearMaxWith = 340;
                const yearScaleX = squeezeText(ctx, yearText, yearMaxWith, yearFont);
                ctx.scale(yearScaleX, 1);
                ctx.fillText(yearText, 810, 350);
                ctx.restore();

            }

            // Draw price if needed
            if (cardData.ShowPrice === 'Show') {
                ctx.save();
                if (cardData.Position === "GK") {
                    ctx.fillStyle = getColor(bgSrc.split('/')[4], 'string');
                } else {
                    ctx.fillStyle = getColor(bgSrc.split('/')[3], 'string');
                }
                const priceText = cardData.Price.toString();
                const priceFont = '55px Renogare';
                const priceMaxWidth = 250; // adjust as needed
                const priceScaleX = squeezeText(ctx, priceText, priceMaxWidth, priceFont);
                ctx.font = priceFont;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.translate(940, 675); // move origin to text position
                ctx.scale(priceScaleX, 1); // squeeze horizontally if needed
                ctx.fillText(priceText, 0, 0);
                ctx.restore();
            }

            // Draw circles and their values
            ctx.fillStyle = 'rgba(255, 255, 255, 0)';
            circles.forEach(c => {
                ctx.beginPath();
                ctx.arc(c.x, c.y, c.r, 0, 2 * Math.PI);
                ctx.fill();

                if ((c.x === 100 && c.y === 690) || (c.x === 300 && c.y === 690)) {
                    if (cardData.Position === "GK") {
                        ctx.fillStyle = getColor(bgSrc.split('/')[4], 'string');
                    } else {
                        ctx.fillStyle = getColor(bgSrc.split('/')[3], 'string');
                    }
                } else {
                    ctx.fillStyle = c.color;
                }
                const circleFont = `${c.font}px Renogare`;
                const circleMaxWidth = 150; // adjust as needed for your circle size
                const circleScaleX = squeezeText(ctx, c.value.toString(), circleMaxWidth, circleFont);
                ctx.font = circleFont;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.save();
                ctx.translate(c.x, c.y);
                ctx.scale(circleScaleX, 1); // squeeze horizontally if needed
                ctx.fillText(c.value, 0, 0);
                ctx.restore();
                ctx.fillStyle = 'rgba(255, 255, 255, 0)';
            });
        });

        // Cleanup
        return () => {

        };
    }, [cardData, playerImage, canvasRef]);


    useEffect(() => {
        const canvas = smallCardCanvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');


        const bgSrc = getSmallBackgroundImage(cardData.PlayerType, cardData.CardType, cardData.Rating);
        const yearBg = `images/bg/yearbg.png`;
        const ratingBgSrc = getRatingBackgroundImage(cardData.CardType, cardData.Rating);
        const posSrc = `images/positions/${cardData.Position}.png`;
        const flagSrc = `images/flags/${countryList[cardData.Nationality]}.png`;
        const playerSrc = playerImage ? playerImage : 'images/playerImages/default_pic.png';

        Promise.all([
            loadImage(bgSrc),
            loadImage(ratingBgSrc),
            loadImage(posSrc),
            loadImage(flagSrc),
            loadImage(playerSrc),
            loadImage(yearBg)
        ]).then(([bgImg, ratingImg, posImg, flagImg, playerImg, yearBg]) => {
            canvas.width = 720;
            canvas.height = 877;
            ctx.clearRect(0, 0, 720, 877);
            ctx.drawImage(bgImg, 0, 0);

            // Draw player image
            ctx.drawImage(playerImg, 251, 96, 395, 400);

            // Draw rating background and number
            const x = 80, y = 100, w = 250, h = 250, radius = 4;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + w - radius, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
            ctx.lineTo(x + w, y + h - radius);
            ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
            ctx.lineTo(x + radius, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(ratingImg, x, y, w, h);
            ctx.restore();

            // Squeeze the rating number if needed
            ctx.save();
            const ratingText = cardData.Rating.toString();
            const ratingFont = '83px Renogare';
            const ratingMaxWidth = 120; // adjust as needed
            const ratingScaleX = squeezeText(ctx, ratingText, ratingMaxWidth, ratingFont);
            ctx.font = ratingFont;
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.translate(x + w / 2, y + h / 2 + 14.5);
            ctx.scale(ratingScaleX, 1); // squeeze horizontally if needed
            ctx.fillText(ratingText, 0, 0);
            ctx.restore();

            // Draw position image
            {
                const px = 388.5, py = 627, pw = 100, ph = 70, pr = 4;
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(px + pr, py);
                ctx.lineTo(px + pw - pr, py);
                ctx.quadraticCurveTo(px + pw, py, px + pw, py + pr);
                ctx.lineTo(px + pw, py + ph - pr);
                ctx.quadraticCurveTo(px + pw, py + ph, px + pw - pr, py + ph);
                ctx.lineTo(px + pr, py + ph);
                ctx.quadraticCurveTo(px, py + ph, px, py + ph - pr);
                ctx.lineTo(px, py + pr);
                ctx.quadraticCurveTo(px, py, px + pr, py);
                ctx.closePath();
                ctx.clip();
                ctx.drawImage(posImg, px, py, pw, ph);
                ctx.restore();
            }

            // Draw flag image
            {
                const fx = 250, fy = 627, fw = 100, fh = 70, fr = 4;
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(fx + fr, fy);
                ctx.lineTo(fx + fw - fr, fy);
                ctx.quadraticCurveTo(fx + fw, fy, fx + fw, fy + fr);
                ctx.lineTo(fx + fw, fy + fh - fr);
                ctx.quadraticCurveTo(fx + fw, fy + fh, fx + fw - fr, fy + fh);
                ctx.lineTo(fx + fr, fy + fh);
                ctx.quadraticCurveTo(fx, fy + fh, fx, fy + fh - fr);
                ctx.lineTo(fx, fy + fr);
                ctx.quadraticCurveTo(fx, fy, fx + fr, fy);
                ctx.closePath();
                ctx.clip();
                ctx.drawImage(flagImg, fx, fy, fw, fh);
                ctx.restore();
            }
            // Draw last name (centered)
            ctx.save();
            ctx.fillStyle = '#000';
            const lastNameText = cardData.LastName.toUpperCase();
            const lastNameFont = '57px Renogare';
            const lastNameMaxWidth = 540; // adjust as needed
            const lastNameScaleX = squeezeText(ctx, lastNameText, lastNameMaxWidth, lastNameFont);
            ctx.font = lastNameFont;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.translate(370, 555); // move origin to text position
            ctx.scale(lastNameScaleX, 1); // squeeze horizontally if needed
            ctx.fillText(lastNameText, 0, 0);
            ctx.restore();
            if (cardData.PlayerType !== 'Normal') {
                ctx.drawImage(yearBg, 26, 325, 360, 205);
                ctx.fillStyle = '#FFF700';
                const yearFont = '73px Renogare'
                ctx.textAlign = 'center';
                ctx.font = yearFont;
                const yearText = cardData.Year.toString();
                ctx.textBaseline = 'middle';
                const yearMaxWith = 340;
                const yearScaleX = squeezeText(ctx, yearText, yearMaxWith, yearFont);
                ctx.scale(yearScaleX, 1);
                ctx.fillText(yearText, 210, 435);
                ctx.restore();
            }
        });
        // Cleanup if needed
        return () => { };
    }, [cardData, playerImage, smallCardCanvasRef]);




    return (
        <div className="canvasWrapper">
            <canvas
                ref={canvasRef}
                style={{
                    display: cardData.Show === 'Game card' ? 'block' : 'none',
                    width: '100%',
                    height: 'auto',
                    maxWidth: '1174px',
                    maxHeight: '720px'
                }}
                width={1174}
                height={720}
            ></canvas>
            <canvas
                ref={smallCardCanvasRef}
                style={{
                    display: cardData.Show === 'Game card' ? 'none' : 'block',
                    width: '100%',
                    height: 'auto',
                    maxWidth: '720px',
                    maxHeight: '877px'
                }}
                width={720}
                height={877}
            ></canvas>

            <div> <b style={{
                fontSize:"22px"
            }}>Upload Photo : &nbsp;</b> <input className='shadow fileUpload' type="file" accept="image/*" onChange={handleFileChange} /></div>
        </div>
    );
}
